"use client";

import { c as _c } from "react/compiler-runtime";
import Container from "@components/Container";
import { logger } from "@justhome/common";
import { ComponentSectionsCtaWithImageV3, UploadFile } from "@lib/generated/graphql";
import CtaWithImageV3 from "@modules/homepage/sections/CtaWithImageV3";
import { usePathname } from "next/navigation";
import { useEffect, useMemo } from "react";

// An `app/` directory owns not-found for the whole site, so this is the 404 for the Pages
// Router too. It came from `pages/404.tsx` with the illustration, the copy and the button
// home; the header and footer are deliberately left out rather than reaching back into the
// Pages Router for them, and the rebuilt ones will fill those slots.
//
// The three strings used to come from next-i18next, which is not mounted here, and are German
// only for now.
const MESSAGES = {
  title: "404: Seite nicht gefunden",
  subTitle: "Wir haben versucht, die von dir gesuchte Seite zu finden, aber es ist uns leider nicht gelungen. Daran arbeiten wir noch im Hintergrund. Bitte kehre zur Startseite zurück. Vielen Dank.",
  buttonLabel: "Startseite"
};
const NotFound = () => {
  const $ = _c(8);
  const pathname = usePathname();
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t0 = () => {
      logger.error("Page not found", new Error(`Path ${pathname} not found`));
    };
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      id: "1",
      direction: "normal",
      firstColumn: 6,
      secondColumn: 5
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      id: "1",
      title: MESSAGES.title,
      subTitle: MESSAGES.subTitle,
      button: {
        id: "1",
        label: MESSAGES.buttonLabel,
        variant: "primary",
        size: "lg",
        type: "button",
        href: "/"
      }
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      width: 400,
      height: 400,
      url: "/assets/img/404-v2.png"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      __typename: "ComponentSectionsCtaWithImageV3",
      id: "1",
      layout: t2,
      text: t3,
      image: {
        id: "1",
        paddingBottom: "md",
        paddingTop: "md",
        image: {
          id: "1",
          fit: "contain",
          position: "center",
          style: "none",
          image: {
            data: {
              id: "1",
              attributes: t4 as UploadFile
            }
          }
        }
      }
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const data = t5 as ComponentSectionsCtaWithImageV3;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Container><CtaWithImageV3 index={0} data={data} /></Container>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
export default NotFound;